import type { ExtractPropTypes } from "vue";

export const AIStatementPropsOption = {
    name: { type: String },
    subject: { type: String },
    visible: { type: Boolean, default: false },
    spacing: { type: Object as PropType<{ x?: number; y?: number }> },
    contexts: { type: Object as PropType<{ default: string; origin: string }>, required: true },
    type: { type: String },
} as const;

export type AIStatementProps = ExtractPropTypes<typeof AIStatementPropsOption>;
